<footer>
  <div class="container">
    <ul>
      <li><a (click)="setTitle('Alexander Koenig - Kontakt')" routerLink="contact" routerLinkActive="active" tabindex="0">Kontakt</a></li>
      <li><a (click)="setTitle('Alexander Koenig - Impressum')" routerLink="impressum" routerLinkActive="active" tabindex="0">Impressum</a></li>
      <li><a (click)="setTitle('Alexander Koenig - Sitemap')" routerLink="sitemap" routerLinkActive="active" tabindex="0">Sitemap</a></li>
    </ul>
  </div>
</footer>
